import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";
import axios from "axios";
import { useLocation } from 'react-router-dom'


class DmsView extends Component{
    constructor(props) {
        super(props);

        this.state = {
            reportPermissionsArray:[],
            tableau_worksheet:[],
            project_name:""
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
    }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        this.get_tableau_worksheet(this.props.match.params.id,decoded.user_department);
    }

    get_tableau_worksheet(workbook_id,user_department){
        axios.post(config.get('API_URL')+'/tableau/get-tableau-worksheet-by-project/',
         {
            project_id:workbook_id,
            user_department:user_department
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {

            if(response.data.length<1){
                alert("You Don't have permission to view this reports")
            } else {
                this.setState({
                    tableau_worksheet: response.data,
                    project_name: response.data[0].project_name,
                    worksheet_name: response.data[0].workbook_name,
                    workbook_kpi_id: response.data[0].workbook_id,
                    project_id: response.data[0].project_id
                })
            }

        }).catch( err => {
            console.log(err);
        });
    }
    render() {
        
        let worksheetData = this.state.tableau_worksheet.map((val,index) => {
            var linkUrl = "/admin/donation-dashboard/"+val.view_id;
            return (
                <React.Fragment key={index + 1}>
                    <Link className="" to={linkUrl}>
                        <div role="alert" className="alert-with-icon  alert alert-info-custom">
                            <span className="pe-7s-graph3"></span> &nbsp;&nbsp;
                            <span data-notify="message">{val.view_name}</span>
                        </div>
                    </Link>
                </React.Fragment>
            )
        });
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="card title-card-bottom-space">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li class="breadcrumb-item">
                                                <Link className="" to="/admin/dms-project/" >Project</Link>
                                            </li>
                                            <li aria-current="page" class="breadcrumb-item active">
                                                {this.state.project_name}
                                            </li>

{/*                                             <li aria-current="page" class="breadcrumb-item active">{this.state.worksheet_name}</li> */}
                                        </ol>
                                    </nav>

                                </div>
                                <div className="content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {worksheetData}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(DmsView);